import axios from 'axios';
import { environment } from "@/shared/config/environment";

const setHeader = (headers, name, value) => {
    if (typeof headers?.set === "function") headers.set(name, value);
    else if (headers) headers[name] = value;
};

var axiosInstance=axios.create({
    headers:{'Content-Type':'application/json'},
    baseURL: environment.apiBaseUrl,
})

axiosInstance.interceptors.request.use(
    request => {
        const apiKey = localStorage.getItem("apikey");
        const token = localStorage.getItem("token");
        if (apiKey) setHeader(request.headers, "X-Accelasearch-Apikey", apiKey);
        if (token) setHeader(request.headers, "X-Accelasearch-Jwt", token);
        return request;
    }
);

axiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            localStorage.removeItem("token");
            localStorage.removeItem("apikey");
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
